<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" color="currentColor"
	><path
		fill="currentColor"
		d="M28 10v18H10V10h18m0-2H10a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2Z"
	/><path fill="currentColor" d="M4 18H2V4a2 2 0 0 1 2-2h14v2H4Z" /></svg
>
